import axios from "axios";
import { useQuery } from "react-query";
import {ApiRoutes} from "../constants/apiRoutes";

export const useHelloApi = () => {
    return useQuery("login", () =>
        axios.get(ApiRoutes.hello)
    );
};
